module.exports = __webpack_public_path__ + "img/dual.1280bab2.png";